import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  overflow: {
    overflow: 'visible',
  },
  dialog: {
    '& h6': {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: '19px',
      lineHeight: '23px',
      letterSpacing: 0,
      paddingTop: 6,
      paddingBottom: 0,
    },
    '& label': {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: 0,
      paddingBottom: 8,
      color: '#4A4A4A',
    },
    '& .MuiGrid-item': {
      paddingTop: 4,
      paddingBottom: 4,
    },
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      marginTop: '10px',
      marginBottom: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#bbb',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa',
    },
    borderRadius: '10px',
    dialogContent: {
      paddingTop: 24,
      paddingBottom: 24,
      paddingLeft: 40,
      paddingRight: 40,
      borderBottom: 'none',
    },
    title: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      fontSize: '0.9em',
      color: '#212121',
      lineHeight: '1.4em',
    },
    subtitle: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      fontSize: '17px',
      color: '#212121',
      lineHeight: '1em',
    },
    dialogTitle: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: '19px',
      lineHeight: '23px',
      letterSpacing: 0,
    },
    actionsContainer: {
      paddingRight: 40,
      paddingLeft: 40,
      paddingBottom: 40,
      paddingTop: 20,
    },
    actionsButton: {
      borderRadius: '10px',
      fontSize: '16px',
      fontWeight: 400,
      fontFamily: 'Arial',
      lineHeight: '18.4px',
      letterSpacing: 0,
      padding: '16px 45px',
    },
    actionsButtonTabs: {
      borderRadius: '5px',
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'Montserrat',
      lineHeight: '100%',
      letterSpacing: 0,
      minWidth: '110px',
      minHeight: '40px',
      textTransform: 'capitalize',
    },
  },
  dialogTitle: {
    padding: '10px 24px',
  },
  tootlTipUsers: {
    backgroundColor: '#27352E26',
    padding: '16px',
    borderRadius: '5px',
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Montserrat',
    lineHeight: '100%',
    letterSpacing: 0,
    minHeight: 60,
  },
  userCountBox: {
    display: 'flex',
    alignItems: 'center',
    background: '#e3e5e4',
    borderRadius: 8,
    borderLeft: '6px solid #26332e',
    padding: '18px',
    margin: '8px 0',
    minHeight: 40,
    fontFamily: 'Montserrat',
    fontSize: 14,
    color: '#26332e',
  },
}))

export { useStyles }
